import * as CookieService from '../CookieService';
import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next'

class UnderMaintananceComponent extends Component {
    constructor(props) {
        super(props);
        this.backToLoginClick = this.backToLoginClick.bind(this);
        
        this.state = {
            displayText: CookieService.getLocalStorageValues("displayText")
            
        }
    }

    backToLoginClick = () => {
        CookieService.updateLocalStorageValues("ShowNormalLogin", true);
        this.props.history.push({
            pathname: '/'
        });
    }
    removeHTMLTags(text) {
        // Create a new div element
        const div = document.createElement('div');

        // Set the innerHTML property of the div to the value of the text parameter
        div.innerHTML = text;

        // Return the plain text content of the div
        return div.textContent || div.innerText || '';
    }

    render() {
        return (<React.Fragment> {this.state.displayText ?
            <div className="container-fluid">
                <div className="custom-under-maintenance d-flex justify-content-center align-items-center vh-100">
                    <div className="text-center">
                        <h3 className="title-item">Site under maintenance</h3>
                        <p className="content-item">
                            <div dangerouslySetInnerHTML={{ __html: this.state.displayText.replace(/<br\s*\/?>/gi, ' ') }} />                              
                        </p>
                        <div className="loader-image-container d-inline-block">
                            <img className="w-100 h-100" src="images/construction.svg" alt="" />
                        </div>
                        <div>
                            <button className="btn custom-btn-primary px-4 m-0 primary-btn-responsive" onClick={() => this.backToLoginClick()}>
                                Back to login
                            </button>
                        </div>
                    </div>
                </div>
            </div> : null}
        </React.Fragment> )
    }
}
export default withTranslation()(UnderMaintananceComponent);